<template>
  <MasonryWall
    :items="photoItems"
    :ssr-columns="2"
    :gap="8"
    :min-columns="2"
    :max-columns="4"
    class="mt-2"
  >
    <template #default="masonryItem">
      <div
        role="button"
        tabindex="0"
        data-test="photoItem"
        class="block bg-gray-100 relative h-0 overflow-hidden cursor-pointer"
        :style="
          calculateAspectRatio(masonryItem.item.height, masonryItem.item.width)
        "
        @click.prevent="emit('openPhotoLightbox', masonryItem.index)"
        @keydown.enter="emit('openPhotoLightbox', masonryItem.index)"
      >
        <TLazyimg
          :ref="
            element => {
              if (element) imageRefs[masonryItem.index] = element
            }
          "
          :alt="masonryItem.item.alt"
          :sources="{ url: masonryItem.item.url }"
          classes-img="block w-full h-full object-cover"
          draggable="false"
          provider="directProvider"
        />
      </div>
    </template>
  </MasonryWall>
</template>

<script setup lang="ts">
import MasonryWall from '@yeger/vue-masonry-wall'

import type { CottagePhotoItemType } from '../../entities/Cottage'

const imageRefs = ref<any[]>([])

export interface propsInterface {
  photoItems: CottagePhotoItemType[]
  currentIndex: number
}

const props = defineProps<propsInterface>()
const emit = defineEmits<{
  openPhotoLightbox: [index: number]
}>()

const calculateAspectRatio = (height: number, width: number) => {
  const value = (height / width) * 100

  return {
    'padding-bottom': `${value}%`,
  }
}

const scrollTo = () => {
  const index = props.currentIndex

  if (imageRefs.value[index]) {
    imageRefs.value[index].$el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest',
    })
  }
}

onMounted(() => {
  setTimeout(() => {
    scrollTo()
  }, 900)
})
</script>
